/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatContent } from '../../models/stat-content';
import { StatContentApiRespModel } from '../../models/stat-content-api-resp-model';

export interface ApiMasterStatContentAddPost$Params {
      body?: StatContent
}

export function apiMasterStatContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterStatContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterStatContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatContentApiRespModel>;
    })
  );
}

apiMasterStatContentAddPost.PATH = '/api/Master/StatContent/Add';
